export default __webpack_public_path__ + "static/media/Frame 11778.b290b256.gif";